import { IManufacturePart } from './../services/manufactures.service';
import { IManufacture, IMake } from './../services/dealer.service';
import { IInvoiceItem } from 'src/app/shared/domain/invoice.entity';

const NAMESPACE = 'NEWTHIRDPATYCLAIM';
const INITIAL_STATE: INewThridPartyState = {
  WizardSession: {
    values: {
      manufacture: <IManufacture>{} ,
      makeId: null,
      makes: [],
      referenceNo: '',
      vin: '',
      ticketId: null,
      parts: [],
      warningFlags: []
    },
    currentStepIsValidate: false,
    currentStep: 1,
    validationMessage: ''
  }
};

export const NewThirdPartyClaimActions = {
  INIT: `${NAMESPACE}.INIT`,
  VALIDATE_WIZARD_STEP: `${NAMESPACE}.VALIDATE_WIZARD_STEP`,
  UPDATE_WIZARD_STEP: `${NAMESPACE}.UPDATE_WIZARD_STEP`,
  UPDATE_WIZARD_VALUES: `${NAMESPACE}.UPDATE_WIZARD_VALUES`,
  SET_MAKES: `${NAMESPACE}.SET_MAKES`,
  SET_MANUFACTURE: `${NAMESPACE}.SET_MANUFACTURE`,
  SET_REFERENCE_NO: `${NAMESPACE}.SET_REFERENCE_NO`,
  SET_VIN: `${NAMESPACE}.SET_VIN`,
  SET_TICKETID: `${NAMESPACE}.SET_TICKETID`,
  SET_PARTS: `${NAMESPACE}.SET_PARTS`,
  UPDATE_WARNING_FLAGS: `${NAMESPACE}.UPDATE_WARNING_FLAGS`,
  CLEAR_WARNINGS_FLAG: `${NAMESPACE}.CLEAR_WARNINGS_FLAG`,
  SET_VALIDATION_MSG: `${NAMESPACE}.SET_VALIDATION_MSG`,
};

export function NewThirdPartyClaimReducer(state: INewThridPartyState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case NewThirdPartyClaimActions.INIT:
      state = INITIAL_STATE;
      return state;
    case NewThirdPartyClaimActions.VALIDATE_WIZARD_STEP:
      state.WizardSession.currentStepIsValidate = action.payload;
      return state;
    case NewThirdPartyClaimActions.UPDATE_WIZARD_STEP:
      state.WizardSession.currentStep = action.payload;
      return state;
    case NewThirdPartyClaimActions.UPDATE_WIZARD_VALUES:
      state.WizardSession.values = action.payload;
      return state;
     case NewThirdPartyClaimActions.SET_MAKES:
      state.WizardSession.values.makes = action.payload;
      return state;
     case NewThirdPartyClaimActions.SET_MANUFACTURE:
      state.WizardSession.values.manufacture = action.payload;
      return state;
      case NewThirdPartyClaimActions.SET_REFERENCE_NO:
      state.WizardSession.values.referenceNo = action.payload;
      return state;
    case NewThirdPartyClaimActions.SET_VIN:
      state.WizardSession.values.vin = action.payload;
      return state;
    case NewThirdPartyClaimActions.SET_TICKETID:
      state.WizardSession.values.ticketId = action.payload;
      return state;
    case NewThirdPartyClaimActions.SET_PARTS:
      state.WizardSession.values.parts = action.payload;
      return state;
    case NewThirdPartyClaimActions.CLEAR_WARNINGS_FLAG:
      state.WizardSession.values.warningFlags = [];
      return state;
    case NewThirdPartyClaimActions.UPDATE_WARNING_FLAGS:
      state.WizardSession.values.warningFlags.concat(action.payload);
      return state;
    case NewThirdPartyClaimActions.SET_VALIDATION_MSG:
      state.WizardSession.validationMessage = action.payload;
      return state;
    default:
      return state;
  }
}



export interface INewThridPartyState {
   WizardSession?: IhridPartyWizardSession;
}
export interface IhridPartyWizardSession {
  values?: IThridPartyWizardValues;
  currentStepIsValidate?: boolean;
  validationMessage?: string;
  currentStep?: number;
}
export  interface IThridPartyWizardValues {
   manufacture: IManufacture;
   makeId: number;
   makes: IMake[];
   referenceNo: string;
   vin: string;
   ticketId: number;
   parts: IManufacturePart[] | IInvoiceItem[];
   warningFlags: string[];
}


